import modelBase from '../models/model-base.model';
import globalConfig from '../config/global-variables'

var resetPasswordModel = {

  reset: function (successCallBack, failureCallBack, oldpassword, newpassword) {
    var params = {}
    params.password = oldpassword
    params.newPassword = newpassword
    modelBase.post(successCallBack, failureCallBack, '/api/user/changepassword', { body: params });
  },
  resetPasswordByAdmin: function (successCallBack, failureCallBack, newpassword, userId) {
    var params = {}
    params.userID = userId
    params.newPassword = newpassword
    modelBase.post(successCallBack, failureCallBack, '/api/user/resetpassword', { body: params });
  },
  resetPassword: function (successCallBack, failureCallBack, password, token) {
    var params = {};
    params.newPassword = password;
    params.token = token;
    m.request({
      method: 'POST',
      url: globalConfig.API_URL + '/api/account/resetpassword',
      headers: { 'Access-Control-Allow-Origin': '*' },
      body: params
    })
      .then(function (result) {
        successCallBack(result)
      })
      .catch(function (error) {
        console.log("error:" + JSON.stringify(error));
        failureCallBack(error)
      })
  }
}

export default resetPasswordModel;
